export default __webpack_public_path__ + "static/media/proposal-gray.af7dfe2e.svg";